function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 173.876 173.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M171.726 80.399v14.67a3.51 3.51 0 0 1-2.705 3.432l-18.21 4.39c-1.206.294-2.149 1.237-2.504 2.427a64.063 64.063 0 0 1-5.781 13.526 3.455 3.455 0 0 0 .015 3.555l9.491 15.52a3.534 3.534 0 0 1-.526 4.344l-10.11 10.11-.263.263a3.535 3.535 0 0 1-4.344.526l-3.957-2.427-11.996-7.343c-1.067-.649-2.381-.649-3.478-.062a63.443 63.443 0 0 1-13.65 5.41c-1.252.34-2.226 1.283-2.52 2.535l-4.282 17.746a3.538 3.538 0 0 1-3.432 2.705H78.789a3.552 3.552 0 0 1-3.432-2.705l-4.421-18.395a3.434 3.434 0 0 0-1.314-1.948h-.015a3.44 3.44 0 0 0-1.082-.557 63.407 63.407 0 0 1-13.217-5.766c-1.113-.634-2.473-.649-3.586.015l-11.872 7.265-3.911 2.396a3.508 3.508 0 0 1-4.328-.526l-10.388-10.372a3.553 3.553 0 0 1-.51-4.344l10.048-16.417c.634-1.067.649-2.365.077-3.463a61.513 61.513 0 0 1-4.916-12.274h-.015c-.077-.263-.139-.541-.216-.804a3.493 3.493 0 0 0-2.535-2.52l-4.158-1.005-14.144-3.401a3.535 3.535 0 0 1-2.705-3.432V78.788a3.536 3.536 0 0 1 2.705-3.432l18.952-4.576c1.221-.278 2.149-1.206 2.52-2.396a61.92 61.92 0 0 1 5.472-12.66c.634-1.113.634-2.473-.031-3.555l-9.924-16.231a3.534 3.534 0 0 1 .526-4.344l10.372-10.372a3.532 3.532 0 0 1 4.344-.51l12.227 7.482h.015l4.421 2.705a3.492 3.492 0 0 0 3.478.077c.448-.247.897-.479 1.36-.696a61.384 61.384 0 0 1 11.439-4.452c1.237-.34 2.195-1.283 2.489-2.535l4.452-18.442a3.522 3.522 0 0 1 3.432-2.705h14.685a3.536 3.536 0 0 1 3.432 2.705l.974 4.004 3.555 14.763a3.49 3.49 0 0 0 2.411 2.52 63.346 63.346 0 0 1 12.969 5.503 3.567 3.567 0 0 0 2.442.386 3.3 3.3 0 0 0 1.097-.433l15.968-9.754a3.527 3.527 0 0 1 4.328.51l8.579 8.579 1.809 1.809a3.527 3.527 0 0 1 .51 4.328l-9.909 16.216a3.485 3.485 0 0 0-.062 3.494 62.74 62.74 0 0 1 5.41 13.371 3.521 3.521 0 0 0 2.535 2.504l14.067 3.385 3.818.928c1.546.356 2.628 1.7 2.69 3.277.015.046.015.108.015.155Z",
    style: {
      fill: "#fff",
      stroke: "#333ccd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.261 53.905v61.074M92.62 60.375h21.365v50.323",
    style: {
      fill: "none",
      stroke: "#333ccd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.124 47.792 88.419 60.497l12.705 12.705",
    style: {
      fill: "none",
      stroke: "#333ccd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.261,
    cy: 60.375,
    r: 11.696,
    style: {
      fill: "#00f2b6",
      stroke: "#00f2b6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.261,
    cy: 110.698,
    r: 11.696,
    style: {
      fill: "#d6d8f5",
      stroke: "#333ccd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.432,
    cy: 110.698,
    r: 11.696,
    style: {
      fill: "#00f2b6",
      stroke: "#00f2b6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.726 80.399v14.67a3.51 3.51 0 0 1-2.705 3.432l-18.21 4.39c-1.206.294-2.149 1.237-2.504 2.427a64.063 64.063 0 0 1-5.781 13.526 3.455 3.455 0 0 0 .015 3.555l9.491 15.52a3.534 3.534 0 0 1-.526 4.344l-10.11 10.11-.263.263a3.535 3.535 0 0 1-4.344.526l-3.957-2.427-11.996-7.343c-1.067-.649-2.381-.649-3.478-.062a63.443 63.443 0 0 1-13.65 5.41c-1.252.34-2.226 1.283-2.52 2.535l-4.282 17.746a3.538 3.538 0 0 1-3.432 2.705H78.789a3.552 3.552 0 0 1-3.432-2.705l-4.421-18.395a3.434 3.434 0 0 0-1.314-1.948h-.015a3.44 3.44 0 0 0-1.082-.557 63.407 63.407 0 0 1-13.217-5.766c-1.113-.634-2.473-.649-3.586.015l-11.872 7.265-3.911 2.396a3.508 3.508 0 0 1-4.328-.526l-10.388-10.372a3.553 3.553 0 0 1-.51-4.344l10.048-16.417c.634-1.067.649-2.365.077-3.463a61.513 61.513 0 0 1-4.916-12.274h-.015c-.077-.263-.139-.541-.216-.804a3.493 3.493 0 0 0-2.535-2.52l-4.158-1.005-14.144-3.401a3.535 3.535 0 0 1-2.705-3.432V78.788a3.536 3.536 0 0 1 2.705-3.432l18.952-4.576c1.221-.278 2.149-1.206 2.52-2.396a61.92 61.92 0 0 1 5.472-12.66c.634-1.113.634-2.473-.031-3.555l-9.924-16.231a3.534 3.534 0 0 1 .526-4.344l10.372-10.372a3.532 3.532 0 0 1 4.344-.51l12.227 7.482h.015l4.421 2.705a3.492 3.492 0 0 0 3.478.077c.448-.247.897-.479 1.36-.696a61.384 61.384 0 0 1 11.439-4.452c1.237-.34 2.195-1.283 2.489-2.535l4.452-18.442a3.522 3.522 0 0 1 3.432-2.705h14.685a3.536 3.536 0 0 1 3.432 2.705l.974 4.004 3.555 14.763a3.49 3.49 0 0 0 2.411 2.52 63.346 63.346 0 0 1 12.969 5.503 3.567 3.567 0 0 0 2.442.386 3.3 3.3 0 0 0 1.097-.433l15.968-9.754a3.527 3.527 0 0 1 4.328.51l8.579 8.579 1.809 1.809a3.527 3.527 0 0 1 .51 4.328l-9.909 16.216a3.485 3.485 0 0 0-.062 3.494 62.74 62.74 0 0 1 5.41 13.371 3.521 3.521 0 0 0 2.535 2.504l14.067 3.385 3.818.928c1.546.356 2.628 1.7 2.69 3.277.015.046.015.108.015.155Z",
    style: {
      fill: "#fff",
      stroke: "#333ccd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.261 53.905v61.074M92.62 60.375h21.365v50.323",
    style: {
      fill: "none",
      stroke: "#333ccd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.124 47.792 88.419 60.497l12.705 12.705",
    style: {
      fill: "none",
      stroke: "#333ccd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.261,
    cy: 60.375,
    r: 11.696,
    style: {
      fill: "#00f2b6",
      stroke: "#00f2b6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.261,
    cy: 110.698,
    r: 11.696,
    style: {
      fill: "#d6d8f5",
      stroke: "#333ccd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 114.432,
    cy: 110.698,
    r: 11.696,
    style: {
      fill: "#00f2b6",
      stroke: "#00f2b6",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.3px"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIac);
export default __webpack_public_path__ + "static/media/iac.ed3120ca43a84c281aa7a9a417ee63c9.svg";
export { ForwardRef as ReactComponent };